/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {GenericObject} from '@ion/core/src/types/entities';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';

/**
 * Provides a utility hook to check the current user role has list
 * of VEHICLE PERMISSIONS feature enabled.
 *
 * ```typescript
 *
 * import {useVehicleModuleFeatures} from '@ion/applications/src/hooks/';
 *
 * const vehicleFeatures = useVehicleModuleFeatures();
 *
 * ```
 *
 */
export const useVehicleModuleFeatures = (Features: GenericObject) => {
  const extendedAttribute   = Features?._userRoles?.[0]?.extendedAttribute;
  const currentUserFeatures = extendedAttribute ? safeJSONParse(extendedAttribute?.value) : [];
  const vehiclePermissions  = currentUserFeatures?.features?.find(
    (item) => Features?.isVehicleFeature(item.id));
  return vehiclePermissions?.features?.filter(item => item?.modules);
};

export default useVehicleModuleFeatures;
